export const objectKeys = <
  T extends Record<TKey, unknown>,
  TKey extends string,
>(
  obj: T,
) => {
  return Object.keys(obj) as [TKey, ...TKey[]];
};
